



































































import {Vue, Component, Prop} from "vue-property-decorator";
import {RiskTableType} from "@/types/riskPrioritization.type";

@Component({components: {}})
export default class RiskPrint extends Vue {
    @Prop() private items!: RiskTableType[];

    headers = [
        {
            text: "Priority",
            align: "start",
            sortable: false,
            value: "order"
        },
        {
            text: "Election Security Survey Component",
            value: "name",
            align: "center"
        },
        {
            text: "Average Risk Score",
            value: "avgRiskScore",
            align: "center"
        },
        {text: "Scale", value: "scale", sortable: false, align: "center"},
        {text: "", value: "labels", sortable: false, align: "start"},
        {
            text: "Risk Score",
            value: "riskScore",
            sortable: false,
            align: "center"
        },
        {
            text: "Capability",
            value: "capability",
            sortable: false,
            align: "center"
        },
        {text: "Importance", value: "importance", sortable: false, align: "end"}
    ];
}
